import meridianLogo from "@assets/images/main-icon.png"; // TODO: replace with main-icon.svg
import useUserStore from "@store/useUserStore";

export function OrganizationLogo() {
  const { activeUser } = useUserStore();

  return (
    <img
      src={
        activeUser?.organization?.logo_url && activeUser?.organization?.logo_url.length > 0
          ? activeUser?.organization?.logo_url
          : meridianLogo
      }
      height="20"
      width="20"
      className="rounded-[4px]"
    />
  );
}
